export default "__VITE_ASSET__BxQUKh$U__"